/** Textos da secção "auth". Chaves planas "auth.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    // RequirePlayerAuth
    "auth.gate.checking": "A verificar a tua conta…",
    "auth.gate.restrictedTitle": "Acesso restrito",
    "auth.gate.leadBeforeDiscord": "Para comprar VIP/kit ou usar o simulador, inicia sessão com ",
    "auth.gate.leadBeforeSteam": ". Depois adiciona a tua ",
    "auth.gate.leadAfterSteam": " no perfil.",
    "auth.gate.discordLogin": "Entrar com Discord",
    "auth.gate.backToSite": "← Voltar ao site",
    "auth.gate.steamRequiredTitle": "SteamID obrigatória",
    "auth.gate.steamRequiredLead":
        "Conta Discord ligada. Falta associar a tua SteamID ao perfil ZRS para continuar.",
    "auth.gate.goToAccount": "Ir para a área da conta",

    // SteamIdBlock
    "auth.steam.configured": "SteamID configurada — podes usar a loja e o simulador.",
    "auth.steam.openProfile": "Abrir perfil Steam",
    "auth.steam.changeNotice": "Confirma que o ID está correto. Para alterar a SteamID, abre um",
    "auth.steam.discordTicket": "ticket no Discord",

    // SteamIdForm
    "auth.steam.hint":
        "Encontra no teu perfil Steam ou em sites como steamid.io. Obrigatória para comprar VIP/kit e usar o simulador.",
    "auth.steam.verifyNotice": "Verifica que a SteamID64 está correta antes de guardar. Para mudar depois, pede via",
    "auth.steam.saving": "A guardar…",
    "auth.steam.save": "Guardar SteamID",
    "auth.steam.invalidInput": "Introduz uma SteamID64 válida (17 dígitos, ex.: 76561198012345678).",
    "auth.steam.saveFailed": "Não foi possível guardar.",

    // lib/playerProfile.js, hooks/usePlayerProfile.js
    "auth.error.supabaseNotConfigured": "Supabase não configurado.",
    "auth.error.invalidSteamId": "SteamID inválida. Usa o formato SteamID64 (17 dígitos, começa por 7656119…).",
    "auth.error.steamIdTaken": "Esta SteamID já está associada a outra conta.",
    "auth.error.steamIdSaveFailed": "Não foi possível guardar a SteamID.",
    "auth.error.profileNotFound": "Perfil não encontrado. Tenta iniciar sessão outra vez.",
    "auth.error.invalidSession": "Sessão inválida.",

    // lib/userDisplay.js
    "auth.discordAccountFallback": "Conta Discord",
};

const en = {
    // RequirePlayerAuth
    "auth.gate.checking": "Checking your account…",
    "auth.gate.restrictedTitle": "Restricted access",
    "auth.gate.leadBeforeDiscord": "To buy VIP/kits or use the simulator, sign in with ",
    "auth.gate.leadBeforeSteam": ". Then add your ",
    "auth.gate.leadAfterSteam": " to your profile.",
    "auth.gate.discordLogin": "Sign in with Discord",
    "auth.gate.backToSite": "← Back to site",
    "auth.gate.steamRequiredTitle": "SteamID required",
    "auth.gate.steamRequiredLead":
        "Discord account linked. Link your SteamID to your ZRS profile to continue.",
    "auth.gate.goToAccount": "Go to account area",

    // SteamIdBlock
    "auth.steam.configured": "SteamID set — you can use the shop and the simulator.",
    "auth.steam.openProfile": "Open Steam profile",
    "auth.steam.changeNotice": "Make sure the ID is correct. To change your SteamID, open a",
    "auth.steam.discordTicket": "Discord ticket",

    // SteamIdForm
    "auth.steam.hint":
        "Find it on your Steam profile or on sites like steamid.io. Required to buy VIP/kits and use the simulator.",
    "auth.steam.verifyNotice": "Double-check your SteamID64 before saving. To change it later, request it via a",
    "auth.steam.saving": "Saving…",
    "auth.steam.save": "Save SteamID",
    "auth.steam.invalidInput": "Enter a valid SteamID64 (17 digits, e.g. 76561198012345678).",
    "auth.steam.saveFailed": "Couldn't save.",

    // lib/playerProfile.js, hooks/usePlayerProfile.js
    "auth.error.supabaseNotConfigured": "Supabase is not configured.",
    "auth.error.invalidSteamId": "Invalid SteamID. Use the SteamID64 format (17 digits, starting with 7656119…).",
    "auth.error.steamIdTaken": "This SteamID is already linked to another account.",
    "auth.error.steamIdSaveFailed": "Couldn't save the SteamID.",
    "auth.error.profileNotFound": "Profile not found. Try signing in again.",
    "auth.error.invalidSession": "Invalid session.",

    // lib/userDisplay.js
    "auth.discordAccountFallback": "Discord account",
};

export default { pt, en };
